<template>
  <BrandProductContent/>
</template>

<script setup lang="ts">
const {$head } = useNuxtApp();
onMounted(() => useHead($head.getEquipment()))
</script>